import { SessionState, SessionActionTypes, UPDATE_SESSION } from './types'

const initialState: SessionState = {
    currentUser: undefined,
    isMobile: false,
    isTablet: false,
    sidebarMenuIsOpen: true,
    aooMenuIsOpen: false,
    indicePAFormFields: [],
    organigrammaFlat: []

}

export function sessionReducer(state = initialState, action: SessionActionTypes): SessionState {
    switch (action.type) {
        case UPDATE_SESSION: {
            return {
                ...state,
                ...action.payload
            }
        }
        default:
            return state
    }
}